import styled from 'styled-components';
import { Container } from "@prima-afp/prima-ui-elements/dist/layouts";
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';
import { Header } from '../../components';

export const ContainerStyled = styled(Container)`
  margin: 0;
  margin-top: ${({ showHeaderOverlay }) => showHeaderOverlay ? '64px' : '0'};
  padding: 4rem 12rem;
  ${media.md`
    padding: 3rem 6.5rem;
  `}
  ${media.sm`
    padding: 3rem 5rem;
  `}
  ${media.xs`
    padding: 2rem 3rem;
  `}
`;

export const HeaderOverlayStyled = styled(Header)`
  position: fixed;
  height: 64px;
  background-color: white;
  width: 100%;
  margin: 0;
  z-index: 99;
  box-shadow: 2px 2px 10px 2px #EBEBEB;
  padding: 2rem 12rem;
  ${media.sm`
    padding-inline: 5rem;
  `}
  ${media.xs`
    padding-inline: 3rem;
  `}
`